import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { Checklist } from '../entities/checklist.entity';

@Injectable({ providedIn: 'root' })
export class TerminateDepotInfrastructure {
  private readonly endpoint = `${environment.apihost}/api/user/termination`;

  constructor(private _http: HttpClient) {}

  public getChecklist(): Observable<Checklist> {
    return this._http.get<Checklist>(`${this.endpoint}/check`);
  }

  public isTerminated(): Observable<boolean> {
    return this._http.get<boolean>(`${this.endpoint}/status`);
  }
}
